// Configuration for connecting React frontend to Flask backend
export const API_CONFIG = {
  // This tells your React app where your Flask backend is running
  BASE_URL: window.location.origin,
  
  // These settings are needed for secure communication
  withCredentials: true,  // Allows cookies to be sent with requests
  timeout: 10000,         // 10 second timeout for API calls
};

export default API_CONFIG;